import React, { useState } from 'react';
import { 
  Paper, 
  Switch, 
  FormControlLabel, 
  Typography, 
  FormControl, 
  Select, 
  MenuItem, 
  InputLabel,
  Divider,
  Box
} from '@mui/material';
import './OrganizationSettings.css';
import Header from '../MainHeader/Header';


const OrganizationSettings = () => {
  const [ssoEnabled, setSsoEnabled] = useState(false);
  const [vaultOption, setVaultOption] = useState('Default');

  const handleSSOChange = (event) => {
    setSsoEnabled(event.target.checked);
  };

  const handleVaultChange = (event) => {
    setVaultOption(event.target.value);
  };

  return (
    <div className="organization-settings-container">
      <Header title="Organization Settings" />
      <Paper elevation={3} className="settings-paper" sx={{ padding: 3 }}>
        <Box className="settings-section">
          <Typography variant="h6" className="settings-section-title" gutterBottom>
            Single Sign-On (SSO)
          </Typography>
          <FormControlLabel
            control={
              <Switch
                checked={ssoEnabled}
                onChange={handleSSOChange}
                color="primary"
              />
            }
            label={ssoEnabled ? "SSO Enabled" : "SSO Disabled"}
          />
          {ssoEnabled && (
            <Typography variant="body2" className="settings-description">
              SSO is currently enabled. Configure your SSO settings in the OneLogin application.
            </Typography>
          )}
        </Box>

        <Divider className="settings-divider" />

        <Box className="settings-section">
          <Typography variant="h6" className="settings-section-title" gutterBottom>
            Vault Configuration
          </Typography>
          <FormControl className="vault-select">
            <InputLabel id="vault-select-label">Vault Option</InputLabel>
            <Select
              labelId="vault-select-label"
              id="vault-select"
              value={vaultOption}
              label="Vault Option"
              onChange={handleVaultChange}
            >
              <MenuItem value="Default">Default</MenuItem>
              <MenuItem value="My Own KMS">My Own KMS</MenuItem>
            </Select>
          </FormControl>
          <Typography variant="body2" className="settings-description">
            {vaultOption === 'Default' 
              ? "Using the default vault configuration provided by the platform."
              : "Using your own Key Management System (KMS) for enhanced security."}
          </Typography>
        </Box>
      </Paper>
    </div>
  );
};

export default OrganizationSettings; 